const dependencies = {
  safeguardingConcernsDetail: {
    controllerCode: 'safeguardingConcerns',
    value: 'Yes'
  }
};

// questions that are never shown — their answer is derived from the session
const autoFilledAnswers = {
  deliveryMethod: sessionDetails =>
    sessionDetails.remote ? 'Online' : 'In-person'
};

export const isAutoFilled = question =>
  Boolean(autoFilledAnswers[question.code]);

export const getAutoFilledAnswer = (question, sessionDetails) =>
  autoFilledAnswers[question.code](sessionDetails);

export const isRequiredQuestion = question => question.isRequired !== false;

export const isAnswered = (answers, questionId) => {
  const answerEntry = answers[questionId] && answers[questionId].answer;
  return (
    answerEntry !== undefined && answerEntry !== null && answerEntry !== ''
  );
};

export const isQuestionVisible = (question, questions, answers) => {
  if (isAutoFilled(question)) return false;
  const rule = dependencies[question.code];
  if (!rule) return true;
  const controller = questions.find(
    candidate => candidate.code === rule.controllerCode
  );
  return (
    !!controller &&
    answers[controller._id] &&
    answers[controller._id].answer === rule.value
  );
};
